// extracted by mini-css-extract-plugin
module.exports = {"swatch":"styles_swatch__3ebew","popover":"styles_popover__3ICLr","cover":"styles_cover__3HMH0"};